import { getApiConfig } from "@/config.js";
import asFormData from "json-form-data";

/**
 * Преобразует объект формы в FormData, сохраняя поля со значением null
 * (превращаются в пустую строку, чтобы бэкенд с ConvertEmptyStringsToNull
 * интерпретировал их как null и очищал значения полей).
 *
 * @param {Object} form
 * @return {FormData}
 */
export const toFormData = form =>
  asFormData(form, {
    includeNullValues: true,
    mapping: value => {
      if (typeof value === "boolean") {
        return +value ? "1" : "0";
      }
      if (value === null) {
        return "";
      }
      return value;
    },
  });

/**
 * Открывет файл и скачивает его
 * @param {string} fileName
 * @param {blob} data
 */
export const downloadFile = (fileName, data) => {
  const a = document.createElement("a");
  const url = window.URL.createObjectURL(data);

  a.href = url;
  a.download = fileName;
  a.target = "_blank";
  document.body.append(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

/**
 * Формирует url для открытия файла из документа пациенат
 *
 * @param {number} customerId
 * @param {number} fileId
 * @return {string}
 */
export const buildDocumentUrl = (customerId, fileId) =>
  `${getApiConfig().url}/v1/customers/${customerId}/documents/file?id=${fileId}`;

export const fileReader = file => {
  const fileReader = new FileReader();

  return new Promise((resolve, reject) => {
    fileReader.onerror = () => {
      fileReader.abort();
      reject(new Error("Problem parsing file"));
    };

    fileReader.onload = () => {
      resolve(fileReader.result);
    };

    fileReader.readAsText(file);
  });
};

export const groupBy = key => array =>
  array.reduce((objectsByKeyValue, obj) => {
    const value = obj[key];
    objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
    return objectsByKeyValue;
  }, {});
